import { CloseIcon, IconFrame } from '@element/icons';
import Backdrop from '@material-ui/core/Backdrop';
import { Elements } from '@stripe/react-stripe-js';
import { APISERVICE } from '@util/apiService/RestClient';
import { useState } from 'react';
import CheckoutForm from './CheckoutForm';

interface StripePaymentModalProps {
  stripeModalDetails: any;
  setStripeModalDetails: (details: any) => void;
  title?: string;
  showCloseButton?: boolean;
}

export default function StripePaymentModal({
  stripeModalDetails,
  setStripeModalDetails,
  title = 'Pay Here',
  showCloseButton = false,
}: StripePaymentModalProps) {
  const [isLoading, setIsLoading] = useState(false);
  const clientSecret = stripeModalDetails?.options?.clientSecret;

  if (!clientSecret) {
    return null;
  }

  const closeStripeWindow = () => {
    setStripeModalDetails({
      ...stripeModalDetails,
      options: { ...stripeModalDetails.options, clientSecret: '' },
    });
    APISERVICE.PUT(
      process.env.NEXT_PUBLIC_STRIPE_PAYMENT + '/cancel?paymentIntentId=' + stripeModalDetails.paymentIntentId,
      null
    );
  };

  return (
    <Backdrop
      className="backdrop-modal-wrapper"
      open={!!clientSecret}
      onClick={showCloseButton ? closeStripeWindow : undefined}
    >
      <div
        className="backdrop-modal-content stripe-modal-content"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="stripe-modal-header">
          <div className="heading">{title}</div>
          {showCloseButton ? (
            <div className="modal-close" onClick={closeStripeWindow}>
              <IconFrame><CloseIcon /></IconFrame>
            </div>
          ) : null}
        </div>
        <Elements options={stripeModalDetails.options} stripe={stripeModalDetails.promise}>
          <CheckoutForm
            stripeModalDetails={stripeModalDetails}
            isLoading={isLoading}
            setIsLoading={setIsLoading}
            setStripeModalDetails={setStripeModalDetails}
          />
        </Elements>
      </div>
    </Backdrop>
  );
}
